import type { App } from '@/background/features/blinks/types';

type AssetName = string;

export type CampaignBlinkAction = Omit<App, 'date'> & {
  description: string;
  icon: string;
  available?: boolean;
};

export type Campaign = {
  id: string;
  name: string;
  text: string;
  airdrops?: AssetName[];
  blinks: CampaignBlinkAction[];
};

type Campaigns = {
  [name: string]: Campaign;
};

const campaigns = [
  {
    id: 'f1-singaporegp-2024',
    name: 'F1 Singapore GP',
    text: 'Welcome to the Exodus F1 event! Your passkey will be fully funded. Get ready for a sleek, buttery-smooth experience in web3!',
    airdrops: ['solana'],
    blinks: [
      {
        url: 'solana-action:https://drift-blinks-qqn6.vercel.app/api/actions/drift/bet?marketIndex=36',
        title: 'Place your 2024 presidential election bet',
        description: 'Will Donald Trump win?',
        icon: 'drif_solana_550a9213',
      },
      {
        url: 'solana-action:https://drift-blinks-qqn6.vercel.app/api/actions/drift/bet?marketIndex=37',
        title: 'Place your 2024 popular vote bet',
        description: 'Will Kamala Harris win?',
        icon: 'drif_solana_550a9213',
      },
    ],
  },
] satisfies Campaign[];

const campaignsByName = campaigns.reduce((result, campaign) => {
  result[campaign.id] = campaign;
  return result;
}, {} as Campaigns);

export default campaignsByName;
